import type { GameEvent, GameSession } from './mascot-game-types'

// Keep physics in sync with MascotFrisbee.php: the server replays inputs, not scores.
export const RUN_DURATION = 600_000
export const STEP = 10
export const JUMP_MS = 800
export const MAX_PICKUP_COINS = 30
export const COIN_HEIGHT = 118
export const OBSTACLES = [
  { width: 30, height: 32, name: 'pedra' },
  { width: 44, height: 44, name: 'tronco' },
  { width: 60, height: 36, name: 'canteiro' },
  { width: 32, height: 48, name: 'cone' },
  { width: 48, height: 46, name: 'caixote' },
  { width: 38, height: 38, name: 'pneu' },
  { width: 68, height: 42, name: 'barreira do parque' },
]
export const START_SPEED = 320
export const runSpeed = (at: number) => START_SPEED + 0.5 * (at / 1000)
export const runDistance = (at: number) =>
  START_SPEED * (at / 1000) + 0.25 * (at / 1000) ** 2
export function jumpHeight(at: number, jumpAt: number) {
  const progress = (at - jumpAt) / JUMP_MS
  return progress > 0 && progress < 1 ? 440 * progress * (1 - progress) : 0
}
export function obstacleX(at: number, encounter: number) {
  return 130 + runDistance(encounter) - runDistance(at)
}
export type RunState = {
  at: number
  jumpAt: number
  cleared: number
  ended: boolean
  collected: number
  coinIndex: number
  lastCoinAt: number
}
export const newRun = (): RunState => ({
  at: 0,
  jumpAt: -JUMP_MS,
  cleared: 0,
  ended: false,
  collected: 0,
  coinIndex: 0,
  lastCoinAt: -1000,
})
export const runScore = (run: RunState) => Math.floor(run.at / 100) + run.cleared * 25
export const runCoins = (score: number) => Math.min(18, Math.floor(score / 500))
export function jump(run: RunState, events: GameEvent[]) {
  if (run.ended || run.at < 1500 || run.at - run.jumpAt < JUMP_MS) return false
  run.jumpAt = run.at
  events.push({ at: run.at, value: 0 })
  return true
}
export function advanceRun(run: RunState, target: number, session: GameSession) {
  const encounters = session.encounters ?? []
  while (!run.ended && run.at + STEP <= Math.min(target, RUN_DURATION)) {
    run.at += STEP
    const index = run.cleared
    if (index < encounters.length) {
      const obstacle = OBSTACLES[session.values[index]]
      const x = obstacleX(run.at, encounters[index])
      if (x + obstacle.width / 2 < 113) run.cleared++
      else if (
        x - obstacle.width / 2 < 147 &&
        jumpHeight(run.at, run.jumpAt) < obstacle.height - 4
      )
        run.ended = true
    }
    const coinAt = session.coins?.[run.coinIndex]
    if (!run.ended && run.coinIndex < MAX_PICKUP_COINS && coinAt !== undefined) {
      const x = obstacleX(run.at, coinAt)
      if (Math.abs(x - 130) <= 31 && jumpHeight(run.at, run.jumpAt) >= 60) {
        run.collected++
        run.coinIndex++
        run.lastCoinAt = run.at
      } else if (x < 99) run.coinIndex++
    }
    if (run.at === RUN_DURATION) run.ended = true
  }
}
